import BaseLayout from './base_layout.vue?vue3';
const IndexLayout = {
    ...BaseLayout,
    name: 'IndexLayout'
};
export default IndexLayout;
